
  import {defineComponent, onMounted, reactive, toRefs} from 'vue'
  import headerText from "@/layout/header/headerText";
  import useStore from "@/store";
  import {useRouter} from "vue-router";
  import informationEdit from "@/components/informationEdit.vue";

  export default defineComponent({
    name: 'index',
    components: {informationEdit},
    setup(props, ctx) {
      const store = useStore()
      const router = useRouter()
      const dataMap = reactive({
        showEdit: false,
        btnName: '我要定制',
        btnName2: '咨询方案',
        softwareText: headerText.menus[3]
      })
      const gotoDetail = (btn) => {
        if (btn && btn.path) {
          router.push({
            path: btn.path
          })
        }
      }
      return {
        ...toRefs(dataMap),
        gotoDetail
      }
    }
  })
